
import React, { useState } from 'react'
import avatar from './../../assets/img/default-avatar.png';
import { UserData } from './Sidebar_Principal';

export interface Props_Card_Sidebar_Principal{
    datos_usuario:UserData
}


export default function Card_Sidebar_Principal(props:Props_Card_Sidebar_Principal) {

    



    
    const {identificacion,nombres,apellidos} = props.datos_usuario;
    
    
    // var srcImagenProfile = identificacion?"https://talentohumano.espol.edu.ec/imgEmpleado/" + identificacion.trim()+ ".jpg" : avatar
    // if(props.datos_usuario.referenciaFotoWeb !== null && props.datos_usuario.referenciaFotoWeb !== undefined){
    //     srcImagenProfile = `http://192.168.1.125/rest/bitstreams/${props.datos_usuario.referenciaFotoWeb.split(",")[1]}/retrieve`
    // }
    var srcImagenProfile = props.datos_usuario.referenciaFotoWeb;
    const [src, setsrc] = useState<string>(srcImagenProfile)
    const [errored, seterrored] = useState(false)

    function onError():void {
        if(!errored){
            setsrc(avatar);
            seterrored(true);
        }
    }

    return (
        <div id={identificacion} className="container_card_sp">
            
                <div  className="pt-3 img-circular text-center">
                    <img  src={src} onError={onError} />
                </div>
                <div className="pt-2">{nombres} </div>
                <div className="pt-1">{apellidos}</div>
                <div>{identificacion}</div>            
        </div>
    )
}






// export default class CardPersonal extends React.Component {

//     constructor(props) {
//         super(props);

//         this.state = {
//             src: this.props.identificacion? "https://talentohumano.espol.edu.ec/imgEmpleado/" + this.props.identificacion.trim() + ".jpg" : avatar,
//             errored: false,
//         };

//         this.onError = this.onError.bind(this);
//     }

//     onError = () => {
//         if (!this.state.errored) {
//             this.setState({
//                 src: avatar,
//                 errored: true,
//             });
//         }
//     }

//     render() {

//         return (
//             <div id={this.props.identificacion}>
//                 <div align="center" className="pt-3">
//                     <img align="center" width="45%" height="45%" src={this.state.src} onError={this.onError} />
//                 </div>
//                 <div align="center" className="pt-2">{this.props.nombres} {this.props.apellidos}</div>

//                 <div align="center">{this.props.identificacion}</div>            
//             </div>
//         );
//     }
// }